export const createArtist = ({
  text = '',
  value = '',
  tripit_ical = undefined,
  created = '',
  short_name = undefined,
  url2 = '',
  artist_announcement = '',
  vat_type_id = undefined,
  artist_name = '',
  default_travel_option2 = undefined,
  phone1 = '',
  default_techrider_eng = '',
  email1 = '',
  artist_id = '',
  url1 = undefined,
  city = '',
  contact_id = '',
  default_travel_qty = '',
  default_hotel_own = undefined,
  signature_url = '',
  techrider_url = '',
  default_catering_eng = undefined,
  default_suites = undefined,
  free_on_date_flag = undefined,
  default_single_rooms = '',
  main_contact_id = '',
  default_hotel_eng = undefined,
  notes = undefined,
  last_name = '',
  default_catering_own = '',
  cost_center = undefined,
  default_feedback = undefined,
  password = '',
  default_performance_time_contract = undefined,
  user_name = '',
  default_agent_commission = undefined,
  default_travel_eng = undefined,
  default_setup_time = undefined,
  performance_type = '',
  phone2 = '',
  default_guestlist_tickets = '',
  default_hotel_stars = '',
  default_travel_own = undefined,
  default_techrider_own = undefined,
  travel_options = '',
  default_double_rooms = undefined,
  first_name = '',
  artist_type = '',
  language = '',
  last_modified = '',
  url3 = ''
}) => {
  return {
    text,
    value,
    tripit_ical,
    created,
    short_name,
    url2,
    artist_announcement,
    vat_type_id,
    artist_name,
    default_travel_option2,
    phone1,
    default_techrider_eng,
    email1,
    artist_id,
    url1,
    city,
    contact_id,
    default_travel_qty,
    default_hotel_own,
    signature_url,
    techrider_url,
    default_catering_eng,
    default_suites,
    free_on_date_flag,
    default_single_rooms,
    main_contact_id,
    default_hotel_eng,
    notes,
    last_name,
    default_catering_own,
    cost_center,
    default_feedback,
    password,
    default_performance_time_contract,
    user_name,
    default_agent_commission,
    default_travel_eng,
    default_setup_time,
    performance_type,
    phone2,
    default_guestlist_tickets,
    default_hotel_stars,
    default_travel_own,
    default_techrider_own,
    travel_options,
    default_double_rooms,
    first_name,
    artist_type,
    language,
    last_modified,
    url3,
    main_contact: `${first_name ? first_name : ''} ${last_name ? last_name : ''}`
  }
};